module.exports = __webpack_public_path__ + "static/media/Card_List_Icon.84068f62.svg";